import React from 'react';
import { Bar } from 'react-chartjs-2';
import { formatAmount } from '../../hooks/useInsightsData';
import { CHART_COLORS } from '../chartOptions';

const PatternCard = ({ patternData }) => {
  const { categoryTotals, fixedExpense, variableExpense, isEmpty } = patternData;

  if (isEmpty) {
    return (
      <div className="insights-card insights-pattern-card">
        <h3 className="insights-card__title">지출 패턴 분석</h3>
        <p className="insights-card__empty">선택한 기간에 지출 데이터가 없습니다</p>
      </div>
    );
  }

  const chartData = {
    labels: categoryTotals.map((item) => item.category),
    datasets: [
      {
        data: categoryTotals.map((item) => item.amount),
        backgroundColor: CHART_COLORS.categories.slice(0, categoryTotals.length),
        borderRadius: 4,
      },
    ],
  };

  const chartOptions = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.parsed.x;
            return `${value.toLocaleString('ko-KR')}원`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value.toLocaleString('ko-KR') + '원';
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 13,
          },
        },
      },
    },
  };

  const formatPercentage = (percentage) => {
    const rounded = Math.round(percentage * 10) / 10;
    if (rounded === 0) return '0';
    return rounded.toFixed(1);
  };

  return (
    <div className="insights-card insights-pattern-card">
      <h3 className="insights-card__title">지출 패턴 분석</h3>
      <div className="insights-pattern-chart">
        <Bar data={chartData} options={chartOptions} />
      </div>
      <div className="insights-pattern-split">
        <div className="insights-pattern-split__item" tabIndex={0}>
          <span className="insights-pattern-split__label">정기지출</span>
          <span className="insights-pattern-split__value">
            {formatAmount(fixedExpense.amount)}원 ({formatPercentage(fixedExpense.percentage)}%)
          </span>
        </div>
        <div className="insights-pattern-split__item" tabIndex={0}>
          <span className="insights-pattern-split__label">변동지출</span>
          <span className="insights-pattern-split__value">
            {formatAmount(variableExpense.amount)}원 ({formatPercentage(variableExpense.percentage)}
            %)
          </span>
        </div>
      </div>
    </div>
  );
};

export default PatternCard;
